import { take, put, call } from 'redux-saga/effects'
import { normalize } from 'normalizr'
import { identity } from 'ramda'
import { batchActivateSupportParameters } from 'services/supportParameters.js'
import { updateStatus } from 'services/referenceParameters.js'
import {
  ACTIVATE_PENDING_SP_RP,
  UPDATE_RP_STATUS,
  RP_ACTIVATION_COMPLETE,
} from 'actions/referenceParameter'
import {
  SUPPORT_PARAM_ACTIVATION_ERROR,
  SP_ACTIVATED,
} from 'actions/supportParameter'
import { referenceParameterSchema } from 'schemas/referenceParameter'
import { addToAsyncSet, removeFromAsyncSet } from 'actions/application'
import strings from 'utils/strings'

export function* watchPendingSupportParameterActivation() {
  while (true) {
    try {
      const {
        pendingSPs,
        rpUri,
        callback = identity,
        errorCallback = identity,
        refParameter,
      } = yield take(ACTIVATE_PENDING_SP_RP)

      yield put(addToAsyncSet({ signal: ACTIVATE_PENDING_SP_RP }))

      const spIds = pendingSPs.map(({ id }) => id)

      try {
        if (spIds.length > 0) {
          yield call(batchActivateSupportParameters, { spIds })
          yield put({ type: SP_ACTIVATED })
        }

        const { data } = yield updateStatus({
          uri: rpUri,
          status: strings.active,
        })
        const normalizeRPData = normalize(data, referenceParameterSchema)

        yield put({ type: RP_ACTIVATION_COMPLETE, refParameter })
        yield put({
          type: UPDATE_RP_STATUS,
          uri: rpUri,
          status: strings.active,
          data: normalizeRPData,
        })

        yield put(removeFromAsyncSet({ signal: ACTIVATE_PENDING_SP_RP }))
        yield callback()
      } catch (err) {
        yield put({ type: SUPPORT_PARAM_ACTIVATION_ERROR })
        yield put(removeFromAsyncSet({ signal: ACTIVATE_PENDING_SP_RP }))
        yield errorCallback()
      }
    } catch (err) {
      throw new Error(err)
    }
  }
}
